<template>
  <div>
    <p>
      <c-button-link
        icon="el-icon-back"
        :to="{ name: 'coach-list' }"
        round
      >
        Zurück zur Coach-Liste
      </c-button-link>

      <c-button-link
        v-if="$is([$config.groups.COACHEE])"
        :to="{
          name: 'coach-invitation',
          params: { id }
        }"
        round
        type="primary"
      >
        Zum Coaching einladen
      </c-button-link>
    </p>

    <h1>{{ coach.profile.name }}</h1>

    <template v-if="coachStatus === $config.status.SUCCESS">
      <img
        v-if="image"
        class="image"
        :alt="`Portrait von ${coach.profile.name}`"
        :src="image"
        width="200"
        height="200"
      >

      <p v-if="coach.profile.rating">
        <el-rate
          :value="coach.profile.rating"
          disabled
          disabled-void-color="#ddd"
          show-score
        />
      </p>

      <p>{{ coach.profile.coreArea }}</p>

      <h2>E-Mail</h2>
      <p>
        <a :href="`mailto:${coach.profile.email}`">
          {{ coach.profile.email }}
        </a>
      </p>

      <h2>Telefon</h2>
      <el-row :gutter="32">
        <el-col
          :sm="12"
          :md="8"
        >
          <p>
            <small>Festnetz</small><br>
            {{ coach.profile.phone }}
          </p>
        </el-col>

        <el-col
          v-if="coach.profile.phoneMobile"
          :sm="12"
          :md="8"
        >
          <p>
            <small>Mobil</small><br>
            {{ coach.profile.phoneMobile }}
          </p>
        </el-col>
      </el-row>

      <h2>Im Programm seit</h2>
      <p>{{ coach.meta.joined | formatDate('long-month') }}</p>

      <c-coach-admin
        v-if="$is([$config.groups.ADMIN])"
        :id="id"
        :last-login="coach.meta.lastLogin"
        :compensation="coach.profile.compensation"
        :website="coach.profile.website"
        :memberships="coach.profile.memberships"
        :documents="coach.profile.documents"
        :is-approved="coach.meta.isApproved"
        @change="getCoach"
      />
    </template>
  </div>
</template>

<script>
import CButtonLink from '@/components/CButtonLink'
import CCoachAdmin from '@/components/CCoachAdmin'

import api from '@/api'
import formatDate from '@/functions/formatDate'
import LoadingOverlay from '@/functions/LoadingOverlay'

export default {
  name: 'VCoachDetail',

  metaInfo () {
    return {
      title: this.coach.profile.name
        ? `Coach „${this.coach.profile.name}“`
        : 'Coach'
    }
  },

  components: {
    CButtonLink,
    CCoachAdmin
  },

  filters: {
    formatDate
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      coachStatus: this.$config.status.IDLE,
      coach: {
        meta: {},
        profile: {}
      },
      image: null
    }
  },

  created () {
    this.getCoach()
    this.getImage()
  },

  destroyed () {
    if (this.image) {
      URL.revokeObjectURL(this.image)
    }
  },

  methods: {
    getCoach () {
      const loadingOverlay = new LoadingOverlay()
      loadingOverlay.start()

      this.coachStatus = this.$config.status.LOADING

      api.coach
        .getSingle(this.id)
        .then(coach => {
          this.coach = coach
          this.coachStatus = this.$config.status.SUCCESS
        })
        .catch(error => {
          this.$notify.error({
            title: 'Fehler',
            message: error.response && error.response.status === 404
              ? 'Dieser Coach konnte leider nicht gefunden werden.'
              : 'Dieser Coach konnte leider nicht geladen werden.'
          })
          this.coachStatus = this.$config.status.ERROR
          this.$router.back()
        })
        .finally(() => {
          loadingOverlay.stop()
        })
    },
    getImage () {
      api.coach
        .getImage(this.id)
        .then(response => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] })
          this.image = URL.createObjectURL(blob)
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Das Portrait konnte nicht geladen werden.'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  margin: 0 0 1em;

  @media (min-width: 30rem) {
    float: right;
    margin: 0 0 1em 1em;
  }
}
</style>
